export enum EvaluationPanelStatus {
  open,
  closed,
}
